"use client";

export interface FilterChip {
  /** Stabiler Schlüssel (z. B. die Achse: „stand“, „zustand“). */
  id: string;
  /** Sichtbarer Text mit Achse und Wert („Stand: Arbeit“). */
  label: string;
}

const CHIP =
  "py-1 ps-2.5 pe-1 inline-flex items-center gap-x-1 text-xs font-medium rounded-full border border-primary-200 bg-primary-100 text-primary-800";
const ENTFERNEN =
  "shrink-0 size-5 inline-flex justify-center items-center rounded-full text-primary-800 hover:bg-primary-200 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none";

/**
 * Aktive Filter als entfernbare Chips (M-015 AV3, Design-Guide `filter-chips.md`): je Achse ein Chip „Achse: Wert“ mit
 * Entfernen-Knopf. Reiner Anzeige- und Entfernen-Baustein; der Aufrufer hält den Filter (und die Adresse). Ohne Chips
 * entfällt der ganze Bereich. Der Text trägt die Aussage; der Entfernen-Knopf nennt den Chip im zugänglichen Namen.
 */
export function FilterChips({
  chips,
  onEntfernen,
  titel = "Aktive Filter",
}: {
  chips: readonly FilterChip[];
  onEntfernen: (id: string) => void;
  titel?: string;
}) {
  if (chips.length === 0) return null;
  return (
    <>
      {/* Preline: component/advanced-select/advanced-select-tags */}
      <ul className="flex flex-wrap items-center gap-1.5" aria-label={titel}>
        {chips.map((c) => (
          <li key={c.id} className={CHIP}>
            <span>{c.label}</span>
            <button type="button" className={ENTFERNEN} aria-label={`Filter entfernen: ${c.label}`} onClick={() => onEntfernen(c.id)}>
              <svg
                className="shrink-0 size-3"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
